import React from "react";
import classes from "./Contact.module.css";
import { motion } from "framer-motion";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { GrMail } from "react-icons/gr";
import { MdPhoneCallback } from "react-icons/md";

function Contact() {
  return (
    <>
      <div className={classes.Contact} id="contact">
        <div className={classes.Connect}>
          {" "}
          <h1>Get in touch</h1>
          <p>
            I'm actively looking for any new opportunities, in full-stack web
            development.
          </p>
        </div>
        <div className={classes.ContactIcons}>
          <motion.div whileHover={{ scale: 1.4 }}>
            <a target="_blank" href="https://github.com/kosachin">
              <FaGithub color="white" size="30px" style={{ padding: "1%" }} />
            </a>
          </motion.div>
          <motion.div whileHover={{ scale: 1.4 }}>
            <a target="_blank" href="https://www.linkedin.com/in/kosachindev/">
              <FaLinkedin color="white" size="30px" style={{ padding: "1%" }} />
            </a>
          </motion.div>
          <motion.div whileHover={{ scale: 1.4 }}>
            <a target="_blank" href="mailto:kosachin313@gmail.com">
              <GrMail color="white" size="30px" style={{ padding: "1%" }} />
            </a>
          </motion.div>
          <motion.div whileHover={{ scale: 1.4 }}>
            <a target="_blank" href="tel:+919820904550">
              <MdPhoneCallback
                color="white"
                size="30px"
                style={{ padding: "1%" }}
              />
            </a>
          </motion.div>
        </div>
      </div>
    </>
  );
}

export default Contact;
